import { render, staticRenderFns } from "./num8.vue?vue&type=template&id=15b97d15&"
import script from "./num8.vue?vue&type=script&lang=js&"
export * from "./num8.vue?vue&type=script&lang=js&"
import style0 from "./num8.vue?vue&type=style&index=0&id=15b97d15&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports